import { Link } from "react-router-dom";
import type { Work } from "@/types";
import { typeLabel } from "@/utils/work";

interface WorkCardProps {
  work: Work;
  className?: string;
}

export default function WorkCard({ work, className = "" }: WorkCardProps) {
  return (
    <Link
      to={`/detail/${work.id}`}
      data-product-shop
      className={`group block overflow-hidden rounded-lg border border-background-200 bg-background-50 transition-all duration-300 hover:border-accent-300 ${className}`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-200">
        <img
          src={work.poster}
          alt={`${work.title} ${work.genre} 封面海报`}
          title={`${work.title} - 国产自拍影视作品`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-2 top-2 rounded-md bg-primary-500/90 px-2 py-0.5 text-xs font-medium text-background-50 backdrop-blur-sm">
          {typeLabel(work.type)}
        </span>
        <span className="absolute right-2 top-2 flex items-center gap-1 rounded-md bg-secondary-500/95 px-2 py-0.5 text-xs font-bold text-secondary-950">
          <i className="ri-star-fill text-[11px]" />
          {work.rating.toFixed(1)}
        </span>
        <div className="absolute inset-x-0 bottom-0 translate-y-full bg-gradient-to-t from-foreground-950/90 to-transparent p-3 text-background-50 transition-transform duration-300 group-hover:translate-y-0">
          <p className="line-clamp-2 text-xs leading-relaxed text-background-100">
            {work.summary}
          </p>
        </div>
      </div>
      <div className="p-3">
        <h3 className="truncate text-sm font-bold text-foreground-950 md:text-base">
          {work.title}
        </h3>
        <div className="mt-1.5 flex flex-wrap items-center gap-1.5 text-xs text-foreground-600">
          <span>{work.year}</span>
          <span className="text-foreground-300">·</span>
          <span className="truncate">{work.genre}</span>
        </div>
      </div>
    </Link>
  );
}